module.exports = __webpack_public_path__ + "./images/8b7340f1058ade14b04b94726dabb2b7.webp";